export const getGaClientId = () => {
  try {
    const tracker = ga.getAll()[0];
    return tracker.get("clientId");
  } catch (e) {
    return null;
  }
};
